import { render } from "./EditLit.vue?vue&type=template&id=ef829f68&scoped=true"
import script from "./EditLit.vue?vue&type=script&lang=js"
export * from "./EditLit.vue?vue&type=script&lang=js"

import "./EditLit.vue?vue&type=style&index=0&id=ef829f68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef829f68"]])

export default __exports__